export const roles = {
    SALES_EXECUTIVE: "sales_executive",
    FINANCE_HEAD: "finance_head",
    FINANCE_EXECUTIVE: "finance_executive",
    AFFILIATE: "affiliate"
}